// extracted by mini-css-extract-plugin
export default {"GaugesContainer":"MyGauge_GaugesContainer__6VOSh","GaugeItemo":"MyGauge_GaugeItemo__8j7y4","GaugeItemo2":"MyGauge_GaugeItemo2__crPX3","GaugeOverflow":"MyGauge_GaugeOverflow__aivPM"};